import type { AnyRouter } from "@tanstack/react-router"
import posthog from "posthog-js"

function hasManualPageview(router: AnyRouter): boolean {
	return router.state.matches.some((match) => match.staticData.manualPageview)
}

export function captureBootPageview(router: AnyRouter): void {
	if (hasManualPageview(router)) return
	posthog.capture("$pageview")
}

export function trackPageviews(router: AnyRouter): void {
	router.subscribe("onResolved", ({ pathChanged }) => {
		if (!pathChanged || hasManualPageview(router)) return
		posthog.capture("$pageview")
	})
}
